import { Actions, Mutations } from "@/store/enums/StoreEnums";

const state = () => {
  return {
    breadcrumbs: [],
    breadcrumbShow: true,
    currentPath: ''
  };
};

// getters
const getters = {
  breadcrumbs: (state) => {
    return state.breadcrumbs
  },
  breadcrumbShow: (state) => {
    return state.breadcrumbShow
  },
  currentPath: (state) => {
    return state.currentPath
  },
};

// actions
const actions = {
};

// mutations
const mutations = {
  [Mutations.SET_BREADCRUMB](state, payload) {
    state.breadcrumbs = payload;
  },
  [Mutations.SET_BREADCRUMB_SHOW](state, payload) {
    state.breadcrumbShow = payload;
  },
  [Mutations.SET_CURRENT_PATH](state, payload) {
    state.currentPath = payload;
  },
};

export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations
};
